import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Axios from 'axios';
import "./App.css";
import { Navbar } from "./components/pages/Navbar";
import Login from "./components/pages/Login";
import Signup from "./components/pages/Signup";
import Create from "./components/pages/create";
import Edit from "./components/pages/edit";
import About from "./components/pages/About";
import Names from "./components/pages/Names";
import Footer from "./components/pages/Footer";
import FAQ from "./components/pages/Faq";
import Creation from "./components/pages/Creation";
import ScrollToTop from "./components/pages/scrollToTop";
import PasswordResetRequest from "./components/pages/PasswordResetRequest";
import PasswordReset from "./components/pages/PasswordReset";

// Attach JWT to every request only when a valid token exists
Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && /^[\w-]+\.[\w-]+\.[\w-]+$/.test(token.trim())) {
    config.headers.Authorization = `Bearer ${token.trim()}`;
  } else if (token) {
    // Remove corrupt/invalid token
    localStorage.removeItem('token');
  }
  return config;
});

function App() {
  const [loginStatus, setLoginStatus] = useState("");
  const [uEmail, setUEmail] = useState("");

  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>
      <ScrollToTop/>
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<About loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
          <Route path="/login" element={<Login loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
          <Route path="/signup" element={<Signup loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
          <Route path="/logout" element={<Login loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>} />
          <Route path="/create" element={<Create loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
          <Route path="/about" element={<About loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
          <Route path="/faq" element={<FAQ loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
          <Route path="/creation" element={<Creation loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
          <Route path="/names" element={<Names loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
          <Route path="/names/:id" element={<Edit loginStatus={loginStatus} setLoginStatus={setLoginStatus} setUEmail={setUEmail} uEmail={uEmail}/>}/>
          <Route path="/password-reset" element={<PasswordResetRequest />} />
          <Route path="/password-reset/:token" element={<PasswordReset />} />
          <Route path="/password-reset-request" element={<PasswordResetRequest />} />
        </Routes>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
